import React from 'react';
import { useQuery } from '@apollo/client';
import { Loader } from '@nile/components';
import AdvancedFilter from '@nile/components/src/Components/AdvancedFilter';
import { GET_PROJECTS_LISTVIEW_META } from "../../Graphql/Query/projects";
import {
    onAttributeSelect,
    onValueSearch
} from '@nile/components/src/Pebbles/AdvancedProjectFilter';

function AdvancedProjectFilter(props) {
    const { updateCondition, conditions } = props;
    const {
        loading: projectListViewMetaLoading,
        data: projectListViewMeta,
        error: projectAutomationError
    } = useQuery(
        GET_PROJECTS_LISTVIEW_META
    );
    if (projectListViewMetaLoading) return <Loader />;
    if (projectAutomationError) return <div>error...</div>;
    const conditionsForAdvancedSearch = conditions?.operands?.[1] || null;
    return (
        <div>
            <AdvancedFilter
                listMeta={projectListViewMeta.getProjectListViewMetaInfo}
                currentModule="project"
                conditions={conditionsForAdvancedSearch}
                onAttributeSelect={onAttributeSelect}
                onValueSearch={onValueSearch}
                updateCondition={updateCondition}
                isNewBuilder
            />
        </div>
    );
}


export default AdvancedProjectFilter;